module.exports = __webpack_public_path__ + "media/images/club-logo/7-54c9a3a0d54a28e74130188f2f08ff10.png";